<div class="w-100 min-vh-100 py-2">
  <div class="row g-4">

    <div class="col-12 col-md-5" [class.d-none]="selectedDepot && !isCreatingNew" [class.d-md-block]="selectedDepot && !isCreatingNew">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="fw-bold mb-0 text-dark">
          Your Depots
          <span class="badge bg-light text-dark ms-2 border fw-normal">
            {{ paginationInfo ? paginationInfo.count : depots.length }}
          </span>
        </h5>
        <button class="btn btn-primary px-4 fw-bold shadow-sm" (click)="initiateNewDepot()">
          <i class="bi bi-plus-lg me-2"></i> Add New Depot
        </button>
      </div>

      <div class="mb-3 d-flex gap-2 justify-content-end align-items-center">
        <div class="position-relative">
          <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
          <input type="text" class="form-control form-control-sm border-0 shadow-sm rounded-pill ps-5 pe-5 w-auto"
            placeholder="Search depots..." [(ngModel)]="search" (ngModelChange)="depotListingSearch$.next($event)">
          <button *ngIf="search" type="button"
            class="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            (click)="search = ''; depotListingSearch$.next('')">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <select class="form-select form-select-sm border-0 shadow-sm rounded-pill ps-3 pe-5 w-auto" style="appearance: none; -webkit-appearance: none; background-position: right 1rem center;"
          [(ngModel)]="currentSort" (change)="onSortChange()">
          <option value="-updated_at">Latest Update</option>
          <option value="-created_at">Newest First</option>
          <option value="created_at">Oldest First</option>
          <option value="name">Name (A-Z)</option>
          <option value="-name">Name (Z-A)</option>
        </select>
      </div>

      <div *ngIf="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary opacity-50" role="status"></div>
        <p class="text-muted mt-2 small">Loading depots...</p>
      </div>

      <div class="d-flex flex-column gap-3" *ngIf="!isLoading">
        <div *ngFor="let depot of depots" (click)="selectDepot(depot)"
          class="card border-0 shadow-sm cursor-pointer transition-all"
          [class.border-primary]="selectedDepot?.id === depot.id"
          [style.background]="selectedDepot?.id === depot.id ? '#f0f7ff' : 'white'">

          <div class="card-body p-3 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-3">
              <div class="rounded-circle p-2"
                [ngClass]="selectedDepot?.id === depot.id ? 'bg-primary-subtle text-primary' : 'bg-light text-secondary'">
                <i class="bi bi-buildings fs-5"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="fw-bold" [class.text-primary]="selectedDepot?.id === depot.id">{{ depot.name }}</span>
                <span class="text-muted small text-truncate" style="max-width: 250px;">
                  {{ depot.full_address || depot.zone_details.name || 'No Zone Set' }}
                </span>
              </div>
            </div>
            <button class="btn btn-link text-danger p-0 border-0" (click)="deleteDepot(depot.id, $event)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <nav class="mt-4" *ngIf="paginationInfo && paginationInfo.total_pages > 1">
          <ul class="pagination pagination-sm justify-content-center align-items-center gap-3">
            <li class="page-item" [class.disabled]="!paginationInfo.previous">
              <button class="page-link border-0 shadow-sm rounded-circle p-2 bg-white text-primary"
                (click)="onPageChange('prev')">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li><span class="small fw-bold text-dark">{{ paginationInfo.current_page }} / {{ paginationInfo.total_pages }}</span></li>
            <li class="page-item" [class.disabled]="!paginationInfo.next">
              <button class="page-link border-0 shadow-sm rounded-circle p-2 bg-white text-primary"
                (click)="onPageChange('next')">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="col-12 col-md-7" [class.d-none]="!selectedDepot && !isCreatingNew" [class.d-md-block]="!selectedDepot && !isCreatingNew">
      <div *ngIf="!selectedDepot && !isCreatingNew"
        class="h-100 d-flex flex-column align-items-center justify-content-center border border-2 border-dashed rounded-4 p-5 text-center bg-white opacity-75">
        <div class="bg-light rounded-circle p-4 mb-3">
          <i class="bi bi-buildings-fill fs-1 text-secondary opacity-50"></i>
        </div>
        <h6 class="fw-bold text-dark">No Depot Selected</h6>
        <p class="text-muted small">Select a depot from the list to view or edit details.</p>
      </div>

      <div *ngIf="selectedDepot && !isCreatingNew" class="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div class="card-header bg-white p-4 border-0 pb-0 d-flex align-items-center gap-2">
          <button class="btn btn-link text-decoration-none text-dark p-0 d-md-none me-2" (click)="cancelEdit()">
            <i class="bi bi-arrow-left fs-4"></i>
          </button>
          <h5 class="fw-bold mb-0 text-dark">Depot Details</h5>
        </div>
        <div class="card-body p-4">
          <form class="row g-3" (submit)="saveDepot()">
            <div class="col-12">
              <label class="form-label fw-bold small text-secondary text-uppercase">Depot Name</label>
              <input type="text" class="form-control bg-light border-0 py-2" [(ngModel)]="selectedDepot.name" name="name">
            </div>

            <div class="col-12">
              <label class="form-label fw-bold small text-secondary text-uppercase">Associated Zone</label>
              <ng-select #editZoneSelect [items]="zoneOptions" bindLabel="label" bindValue="value" placeholder="Search zone..."
                [(ngModel)]="selectedDepot.zone_details.id" name="editZone" [typeahead]="zoneSearchTerm$"
                [loading]="isLoadingZones" (change)="onZoneSelected($event); editZoneSelect.searchTerm = ''">
              </ng-select>
            </div>

             <div class="col-12">
              <label class="form-label fw-bold small text-secondary text-uppercase">Full Address</label>
              <input type="text" #addressInput class="form-control bg-light border-0 py-2"
                placeholder="Start typing address..." [(ngModel)]="selectedDepot.full_address" name="editAddress"
                (input)="selectedDepot.full_address = $any($event.target).value">
            </div>

            <div class="col-md-6">
              <label class="form-label fw-bold small text-secondary text-uppercase">Latitude</label>
              <input type="text" class="form-control bg-light" [(ngModel)]="selectedDepot.lat" name="lat">
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold small text-secondary text-uppercase">Longitude</label>
              <input type="text" class="form-control bg-light" [(ngModel)]="selectedDepot.lng" name="lng">
            </div>

            <div class="col-12 mt-4 pt-3 border-top d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-light px-4" (click)="cancelEdit()">Cancel</button>
              <button type="submit" class="btn btn-primary px-4 fw-bold shadow-sm" [disabled]="isLoading">
                Update Depot
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <ng-template #depotModalTemplate let-modal>
    <div class="modal-header border-0 pt-4 px-4">
      <h5 class="modal-title fw-bold text-dark">Add New Depot</h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body p-4 pt-2">
      <div class="row g-3" *ngIf="selectedDepot">
        <div class="col-12">
          <label class="form-label fw-bold small text-secondary text-uppercase">Depot Name</label>
          <input type="text" class="form-control bg-light border-0 py-2" [(ngModel)]="selectedDepot.name" name="newName">
        </div>

        <div class="col-12">
          <label class="form-label fw-bold small text-secondary text-uppercase">Associated Zone</label>
          <ng-select #newZoneSelect [items]="zoneOptions" bindLabel="label" bindValue="value" placeholder="Search zone..."
            [(ngModel)]="selectedDepot.zone_details.id" name="newZone" [typeahead]="zoneSearchTerm$"
            [loading]="isLoadingZones" (change)="onZoneSelected($event); newZoneSelect.searchTerm = ''">
          </ng-select>
        </div>

        <div class="col-12">
          <label class="form-label fw-bold small text-secondary text-uppercase">Full Address</label>
          <input type="text" #modalAddressInput class="form-control bg-light border-0 py-2"
            placeholder="Start typing address..." [(ngModel)]="selectedDepot.full_address" name="newAddress"
            (input)="selectedDepot.full_address = $any($event.target).value">
        </div>

        <div class="col-md-6">
          <label class="form-label fw-bold small text-secondary text-uppercase">Latitude</label>
          <input type="text" class="form-control bg-light" [(ngModel)]="selectedDepot.lat" name="newLat">
        </div>
        <div class="col-md-6">
          <label class="form-label fw-bold small text-secondary text-uppercase">Longitude</label>
          <input type="text" class="form-control bg-light" [(ngModel)]="selectedDepot.lng" name="newLng">
        </div>
      </div>
    </div>
    <div class="modal-footer border-0 p-4 pt-0 gap-2">
      <button type="button" class="btn btn-light px-4" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary px-4 fw-bold shadow-sm" (click)="saveDepot()" [disabled]="isLoading">
        Create Depot
      </button>
    </div>
  </ng-template>
</div>
